module.exports = new __parcel__URL__("login_poster_1.9a05ff18.png").toString();